export default function videoThumbDepoimento() {
    // Gera Thumbs dos vídeos dos depoimentos
    document.addEventListener('DOMContentLoaded', () => {
        const cards = document.querySelectorAll('.testimonials__card');

        cards.forEach((card) => {
            const videoUrl = card.dataset.video;
            if (!videoUrl) return;

            const img = card.querySelector('.testimonials__card-image');
            if (!img) return;

            // Verifica se é um link do YouTube
            const youtubeRegex = /(?:youtube\.com\/.*v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            const match = videoUrl.match(youtubeRegex);

            if (match && match[1]) {
                const videoId = match[1];
                const thumbUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
                img.src = thumbUrl;
                return; // Não gera frame, usa thumbnail do YouTube
            }

            const cacheKey = `thumb_${btoa(videoUrl)}`;
            const cachedThumb = localStorage.getItem(cacheKey);

            if (cachedThumb) {
                img.src = cachedThumb;
                return;
            }

            const video = document.createElement('video');
            video.src = videoUrl;
            video.crossOrigin = 'anonymous';
            video.muted = true;
            video.playsInline = true;

            video.addEventListener('loadeddata', async () => {
                try {
                    // tenta avançar um pouco para garantir frame válido
                    video.currentTime = 0.5;

                    // espera o seek terminar
                    video.addEventListener('seeked', () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;
                        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

                        const thumb = canvas.toDataURL('image/webp', 0.8);
                        img.src = thumb;

                        try { localStorage.setItem(cacheKey, thumb); }
                        catch (e) { console.warn('Cache falhou', e); }
                    }, { once: true });

                } catch (err) {
                    console.error('Erro ao gerar thumbnail', err);
                }
            });

            video.addEventListener('error', (e) => {
                console.error('Falha ao carregar vídeo:', videoUrl, e);
            });
        });
    });
}
